class RuqyContact extends HTMLElement {
  connectedCallback() {
    this.topicInput = this.querySelector('[data-contact-topic-input]');
    this.topicSelect = this.querySelector('[data-contact-topic-select]');
    this.topicButtons = Array.from(this.querySelectorAll('[data-contact-topic]'));

    this.topicButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectTopic(button.dataset.contactTopic));
    });

    this.topicSelect?.addEventListener('change', (event) => this.selectTopic(event.target.value));
  }

  selectTopic(topic) {
    if (!topic) return;

    if (this.topicInput) this.topicInput.value = topic;
    if (this.topicSelect && this.topicSelect.value !== topic) this.topicSelect.value = topic;

    this.topicButtons.forEach((button) => {
      const isActive = button.dataset.contactTopic === topic;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }
}

if (!customElements.get('ruqy-contact')) {
  customElements.define('ruqy-contact', RuqyContact);
}
